export const API_SERVER = process.env.REACT_APP_SERVER_API;
export const ASSETS_URL = process.env.REACT_APP_ASSETS_URL;
export const APP_THEME = '_app_theme';
export const ASSETS_URL_LOGIN = process.env.REACT_APP_SERVER_API;
export const SERVER_TYPE = process.env.REACT_APP_SERVER_TYPE;
export const USER_INFO = '_user_info';
export const ID_TOKEN = '_id_tk';
export const REFRESH_TOKEN = '_rf_tk';
export const IS_AUTH = '_is_auth';
export const ACCESS_TOKEN = '_ac_tk';
export const BASE_URL = process.env.REACT_APP_URL_BASE;
export const APP_BASE_URL = process.env.REACT_APP_BASE_URL;
